/**
 * ****************************************************************************
 * @description     :   Route for bb app
 * @created at      :   2023/02/20
 * @created by      :   ANS774 – kyvd@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const bb001000l = () => import('@/views/bb/bb001000l');
const bb001000i = () => import('@/views/bb/bb001000i');
const bb002000l = () => import('@/views/bb/bb002000l');
const bb003000l = () => import('@/views/bb/bb003000l');

/**
 * Defined Router
 */
export default [
    {
        path: '/bb/bb001000l',
        name: 'Bb001000l',
        component: bb001000l,
        meta: {
            title: 'その他売上リスト',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bb/bb001000i',
        name: 'Bb001000i',
        component: bb001000i,
        meta: {
            title: 'その他売上入力',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bb/bb002000l',
        name: 'Bb002000l',
        component: bb002000l,
        meta: {
            title: '売上集計一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bb/bb003000l',
        name: 'Bb003000l',
        component: bb003000l,
        meta: {
            title: '所属隊員事業所別売上一覧',
            layout: 'MainLayout'
        }
    }
];
